import { Grid }                           from '@mui/material';
import qs                                 from 'qs';
import React, { FC, ReactNode, useContext, useMemo } from 'react';
import { useLocation }                    from 'react-router-dom';
import { Layout }                         from '../../Layout/Layout';
import { useFetchSelectedFamily }         from '../../shared/components/SelectFamily/queries';
import { isAdminRoles }                   from '../../shared/functions';
import { useFetchFamilyMembers }          from '../../shared/queries/family';
import AuthorizationContext               from '../../shared/utils/withAuthorization/authorizationContext';
import { AboutMemberPreview }             from './about/AboutMemberPreview';
import { ActivityListPreview }            from './activity/ActivityListPreview';
import { ContactsListPreview }            from './contacts/ContactsListPreview';
import { DocumentsListPreview }           from './documents/DocumentsListPreview';
import { EventsListPreview }              from './events/EventsListPreview';
import { SummaryPageHead }                from './shared/SummaryPageHead';
import { TasksListPreview }               from './tasks/TasksListPreview';

interface FCGridProps {
    children: ReactNode; // Tell TS this component accepts children
}
const FCGrid: FC<FCGridProps> = ({ children }) => (
  <Grid
    item
    xs={12}
    md={6}
  >
    { children }
  </Grid>
);

export const MyFamilyCore: FC = () => {
  const { data: family, isLoading: loadingFamily } = useFetchSelectedFamily();
  const { data: familyMembers } = useFetchFamilyMembers(family?.id, { enabled: !!family?.id });
  const { search } = useLocation();
  const params: any = qs.parse(search, { ignoreQueryPrefix: true });
  const familyMemberId = params?.id as string;
  const currentUser = familyMembers?.find(user => user.id === params.id);
  const user = useContext(AuthorizationContext);
  const isAdminRole = isAdminRoles(user?.data?.accountType);

  const Page = (
    <>
      <SummaryPageHead title="My Family Core" />

      <Grid
        container
        spacing={3}
      >
        { isAdminRole && familyMemberId && currentUser?.viewAboutMe && (
          <FCGrid>
            <AboutMemberPreview
              familyId={family?.id}
              familyMemberId={familyMemberId}
            />
          </FCGrid>
        ) }

        <FCGrid>
          <ActivityListPreview
            familyId={family?.id}
            familyMemberId={familyMemberId}
          />
        </FCGrid>

        <FCGrid>
          <EventsListPreview
            familyId={family?.id}
            familyMemberId={familyMemberId}
          />
        </FCGrid>

        <FCGrid>
          <DocumentsListPreview
            familyId={family?.id}
            familyMemberId={familyMemberId}
          />
        </FCGrid>

        <FCGrid>
          <TasksListPreview
            familyId={family?.id}
            familyMemberId={familyMemberId}
          />
        </FCGrid>

        <FCGrid>
          <ContactsListPreview
            familyId={family?.id}
            familyMemberId={familyMemberId}
          />
        </FCGrid>
      </Grid>
    </>
  );

  return useMemo(() =>
    (<Layout>
      { Page }
    </Layout>), [ search, loadingFamily, currentUser, family ]
  );
};
